import { render, staticRenderFns } from "./OwnersDocsEdit.vue?vue&type=template&id=c1f1c3d6&scoped=true&"
import script from "./OwnersDocsEdit.vue?vue&type=script&lang=js&"
export * from "./OwnersDocsEdit.vue?vue&type=script&lang=js&"
import style0 from "./OwnersDocsEdit.vue?vue&type=style&index=0&id=c1f1c3d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1f1c3d6",
  null
  
)

export default component.exports